import { createStore } from "redux"

import { composeWithDevTools } from "redux-devtools-extension"

// combine all the different reducers in the rootReducer
import rootReducers from "./reducers/rootReducer"

// convert object to string and store in localStorage
function saveToLocalStorage(state) {
  try {
    const serialisedState = JSON.stringify(state)
    console.log(serialisedState)
    localStorage.setItem("todoList", serialisedState)
  } catch (e) {
    console.warn(e)
  }
}

// load string from localStarage and convert into an Object
// invalid output must be undefined
function loadFromLocalStorage() {
  try {
    const serialisedState = localStorage.getItem("todoList")
    if (serialisedState === null) return undefined
    JSON.parse(serialisedState)

    var state = {
      todos: {
        // todoList is what needs to be past to the different pages that need to access it
        todoList: JSON.parse(serialisedState),
        // todoId: 1,
        currentTodo: null,
        currentTodoName: "Editable Todo Name",
        currentPomodoroNumber: 0,
        todoFinished: 0,
        pomodoroFinished: 0,
        pomodoroTime: 25,
        shortRestTime: 5,
        longRestTime: 15,
        currentDate: new Date(),
        endTime: null,
      },
      counter: null,
      visibilityFilter: null,
    }

    return state
  } catch (e) {
    console.warn(e)
    return undefined
  }
}

// create our store from our rootReducers and use loadFromLocalStorage
// to overwrite any values that we already have saved
const store = createStore(
  rootReducers,
  loadFromLocalStorage(),
  composeWithDevTools
)

// listen for store changes and use saveToLocalStorage to
// save them to localStorage
store.subscribe(function () {
  console.log(store.getState())
  saveToLocalStorage(store.getState().todos.todoList)
})

// const store = createStore(rootReducer, composeWithDevTools())

export default store

// import { createStore as reduxCreateStore } from "redux"
// import { composeWithDevTools } from "redux-devtools-extension"
// import { INCREMENT, DECREMENT } from "./counter.types"

// const INITIAL_STATE = {
//   count: 0,
// }

// const reducer = (state = INITIAL_STATE, action) => {
//   switch (action.type) {
//     case INCREMENT:
//       return {
//         ...state,
//         count: state.count + 1,
//       }

//     case DECREMENT:
//       return {
//         ...state,
//         count: state.count - 1,
//       }

//     default:
//       return state
//   }
// }

// const store = reduxCreateStore(reducer, composeWithDevTools())
// export default store
